import { RouteObject } from 'react-router-dom';

export default [
  {
    path: '/a/:accountName',
    lazy: async () => {
      const { DashboardLayout } = await import('@/layouts/DashboardLayout');
      return { Component: DashboardLayout };
    },
    children: [
      {
        index: true,
        lazy: () => import('@/pages/account/home')
      },
      {
        path: 'reporting',
        lazy: () => import('@/pages/account/reporting')
      },
      {
        path: 'settings',
        lazy: () => import('@/pages/account/settings')
      },
      {
        path: 'patients',
        children: [
          {
            index: true,
            lazy: () => import('@/pages/account/patients')
          },
          {
            path: ':id',
            lazy: () => import('@/pages/account/patients-details/layout'),
            children: [
              {
                index: true,
                lazy: () => import('@/pages/account/patients-details')
              }
            ]
          }
        ]
      },
      {
        path: 'invoices',
        lazy: () => import('@/pages/account/invoices')
      },
      {
        path: 'invoices/:id',
        lazy: () => import('@/pages/account/invoices-details')
      },
      {
        path: 'orders',
        lazy: () => import('@/pages/account/orders')
      },
      {
        path: 'orders/:id',
        lazy: () => import('@/pages/account/orders-details')
      },
      {
        path: 'team',
        lazy: () => import('@/pages/account/team')
      },
      {
        path: 'incentive-game-points',
        lazy: () => import('@/pages/account/incentive-game-points')
      },
      {
        path: 'catalog',
        lazy: () => import('@/pages/account/catalog')
      },
      {
        path: 'resource-library',
        lazy: () => import('@/pages/account/resource-library')
      }
    ]
  }
] as RouteObject[];
